let elements = {
  withoutReset: true,
  mainImage: {
    imagePath: 'games/page765_game1/img/bcg.jpg',
    pos: {
      x: 180,
      y: 0,
    },
    width: 1554,
    height: 1080,
  },
  withoutCheck: true,
  //imageHighlight: false,
  //imageHighlightColor: 'red',
  mbAudioItemData: [
    {
      src: 'games/page765_game1/audio/36_sing.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page765_game1/img/audioOn.png', iconOff: 'games/page765_game1/img/audioOff.png' },
        fill: 'none',
      },
      width: '40px',
      height: '40px',
      pos: {
        y: 60,
        x: 660,
      },
      unit: 'px',
    },
    {
      src: 'games/page765_game1/audio/31_ball.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page765_game1/img/audioOn.png', iconOff: 'games/page765_game1/img/audioOff.png' },
        fill: 'none',
      },
      width: '40px',
      height: '40px',
      pos: {
        y: 60,
        x: 840,
      },
      unit: 'px',
    },
    {
      src: 'games/page765_game1/audio/41_paint.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page765_game1/img/audioOn.png', iconOff: 'games/page765_game1/img/audioOff.png' },
        fill: 'none',
      },
      width: '40px',
      height: '40px',
      pos: {
        y: 60,
        x: 1030,
      },
      unit: 'px',
    },
    {
      src: 'games/page765_game1/audio/29_car.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page765_game1/img/audioOn.png', iconOff: 'games/page765_game1/img/audioOff.png' },
        fill: 'none',
      },
      width: '40px',
      height: '40px',
      pos: {
        y: 60,
        x: 1240,
      },
      unit: 'px',
    },
    {
      src: 'games/page765_game1/audio/42_jump.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page765_game1/img/audioOn.png', iconOff: 'games/page765_game1/img/audioOff.png' },
        fill: 'none',
      },
      width: '40px',
      height: '40px',
      pos: {
        y: 60,
        x: 1410,
      },
      unit: 'px',
    },
    {
      src: 'games/page765_game1/audio/33_one.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page765_game1/img/audioOn.png', iconOff: 'games/page765_game1/img/audioOff.png' },
        fill: 'none',
      },
      width: '40px',
      height: '40px',
      pos: {
        y: 60,
        x: 1580,
      },
      unit: 'px',
    },

    {
      src: 'games/page765_game1/audio/32_robot.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page765_game1/img/audioOn.png', iconOff: 'games/page765_game1/img/audioOff.png' },
        fill: 'none',
      },
      width: '40px',
      height: '40px',
      pos: {
        y: 945,
        x: 310,
      },
      unit: 'px',
    },
    {
      src: 'games/page765_game1/audio/40_run.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page765_game1/img/audioOn.png', iconOff: 'games/page765_game1/img/audioOff.png' },
        fill: 'none',
      },
      width: '40px',
      height: '40px',
      pos: {
        y: 945,
        x: 500,
      },
      unit: 'px',
    },
    {
      src: 'games/page765_game1/audio/34_two.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page765_game1/img/audioOn.png', iconOff: 'games/page765_game1/img/audioOff.png' },
        fill: 'none',
      },
      width: '40px',
      height: '40px',
      pos: {
        y: 945,
        x: 690,
      },
      unit: 'px',
    },
    {
      src: 'games/page765_game1/audio/39_dance.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page765_game1/img/audioOn.png', iconOff: 'games/page765_game1/img/audioOff.png' },
        fill: 'none',
      },
      width: '40px',
      height: '40px',
      pos: {
        y: 945,
        x: 890,
      },
      unit: 'px',
    },
    {
      src: 'games/page765_game1/audio/30_doll.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page765_game1/img/audioOn.png', iconOff: 'games/page765_game1/img/audioOff.png' },
        fill: 'none',
      },
      width: '40px',
      height: '40px',
      pos: {
        y: 945,
        x: 1080,
      },
      unit: 'px',
    },
    {
      src: 'games/page765_game1/audio/37_catch.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page765_game1/img/audioOn.png', iconOff: 'games/page765_game1/img/audioOff.png' },
        fill: 'none',
      },
      width: '40px',
      height: '40px',
      pos: {
        y: 945,
        x: 1270,
      },
      unit: 'px',
    },
    {
      src: 'games/page765_game1/audio/35_three.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page765_game1/img/audioOn.png', iconOff: 'games/page765_game1/img/audioOff.png' },
        fill: 'none',
      },
      width: '40px',
      height: '40px',
      pos: {
        y: 945,
        x: 1470,
      },
      unit: 'px',
    },
    {
      src: 'games/page765_game1/audio/38_clap.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page765_game1/img/audioOn.png', iconOff: 'games/page765_game1/img/audioOff.png' },
        fill: 'none',
      },
      width: '40px',
      height: '40px',
      pos: {
        y: 945,
        x: 1660,
      },
      unit: 'px',
    },
  ],
};

export default elements;
